import type { TreatmentFacts } from '../types/care';

export type FactKind = 'guidance' | 'duration' | 'home' | 'sessions' | 'sedation' | 'fasting' | 'driving';

export interface FactItem {
  kind: FactKind;
  label: string;
  value: string;
}

export function getTreatmentFacts(facts: TreatmentFacts): FactItem[] {
  const items: FactItem[] = [];
  if (facts.guidance) items.push({ kind: 'guidance', label: 'Techniek', value: facts.guidance });
  if (facts.duration) items.push({ kind: 'duration', label: 'Duur', value: facts.duration });
  if (facts.home) items.push({ kind: 'home', label: 'Naar huis', value: facts.home });
  if (facts.sessions) items.push({ kind: 'sessions', label: 'Frequentie', value: facts.sessions });
  if (facts.sedation) items.push({ kind: 'sedation', label: 'Sedatie', value: 'Lichte slaap tijdens de behandeling' });
  if (facts.fasting) items.push({ kind: 'fasting', label: 'Nuchter', value: 'Licht ontbijt tot 4 uur vooraf' });
  if (facts.noDriving) items.push({ kind: 'driving', label: 'Vervoer', value: 'Niet zelf rijden op de behandeldag' });
  return items;
}
